"use client";

import { useSupabase } from "@/app/supabase-provider";
import { chatEmailSecretOptions } from "@/hooks/queries/user/chatEmailSecretOptions";
import { userOptions } from "@/hooks/queries/user/userOptions";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

export default function PylonProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user: authUser } = useSupabase();

  const { data: user } = useQuery(userOptions({ enabled: !!authUser }));
  const { data: emailSecret } = useQuery(
    chatEmailSecretOptions({ enabled: !!user })
  );

  // We\'re safe to use the direct injection here, as we have to manually update the integrity hash (if they change the underlying JS)
  // only issue to watch out for is when they do change the JS, we have to manually update the integrity hash here
  // https://support.usepylon.com/articles/6473476154-pin-the-in-app-chat-script-to-an-integrity-attribute
  const pylonScript = `
  (function(){var t=window;var e=document;var r=function(){r.e(arguments)};r.q=[];r.e=function(t){r.q.push(t)};t.Pylon=r;var i=function(){var t=e.createElement("script");t.setAttribute("type","text/javascript");t.setAttribute("async","true");t.setAttribute("src","https://widget.usepylon.com/widget/9153d235-ea5c-41b4-99d0-90bcec9cd242");t.setAttribute("integrity","sha384-jETSUzeN707WmOyc2r17Rhhov/vcHLoRB/g6bfG1Sk9YynpWwANGiZshbgsY6v36");t.setAttribute("crossorigin","anonymous");var r=e.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r)};if(e.readyState==="complete"){i()}else if(t.addEventListener){t.addEventListener("load",i,false)}})();
  `;
  useEffect(() => {
    const s = document.createElement("script");
    s.innerHTML = pylonScript;
    document.head.appendChild(s);
  }, []);

  // helper to set the pylon object on the window without having to repeat casting and linter disabling
  const setWindowPylon = (
    pylon: { chat_settings?: any } // eslint-disable-line @typescript-eslint/no-explicit-any
  ) => ((window as any).pylon = pylon); // eslint-disable-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access

  useEffect(() => {
    if (user) {
      setWindowPylon({
        chat_settings: {
          app_id: "9153d235-ea5c-41b4-99d0-90bcec9cd242",
          email: user.email ?? "",
          name: user.name ?? "",
          avatar_url: user.avatar_url ?? "",
          email_hash: emailSecret?.chatEmailSecret ?? "",
        },
      });
    }
  }, [user, emailSecret]);

  return children;
}
